/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import { ITiposEntregaResponse } from "@/hooks/tipos-entregas/buscar-tipos-entrega/index.d";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetTiposEntregas } from "@/domain/use-cases/tipos-entregas";

function useBuscarTiposEntrega() {
  const { token: accessToken } = useStoreZustandUserAuth();

  // Chave de cache única baseada na página atual e na quantidade de itens por página
  const queryKey = ["tipos_entrega"];

  const {
    isLoading,
    error: isError,
    data: tiposEntregaResponse,
  } = useQuery<ITiposEntregaResponse>({
    queryKey,
    enabled: !!accessToken,
    queryFn: async () => {
      const response = await handleGetTiposEntregas(accessToken!, 1, 1, "");

      return response;
    },
    staleTime: 1000 * 60 * 2, // evita múltiplas requisições em 02 min
  });

  const tiposEntrega = tiposEntregaResponse?.data ?? [];

  return {
    tiposEntrega: tiposEntrega,
    isLoading,
    isError,
  };
}

/**
 * EXPORTS
 */
export { useBuscarTiposEntrega };
